export interface IMapMarker {
  id: string;
  lat: number;
  lng: number;
  icon?: string;
  isSelected?: boolean;
  height?: number;
  width?: number;
  /** GB - this will allow us to also have a really custom
   * info window in addition to just a simple string
   */
  content?: JSX.Element | string;
  name: string;
  rank: number;
}

export class MapMarker implements IMapMarker {
  public id: string;
  public lat: number;
  public lng: number;
  public icon: string = null;
  public isSelected = false;
  public height = 25;
  public width = 25;
  public content: JSX.Element | string = "";
  public name = "";
  public rank = 0;

  constructor(id: string, lat: number, lng: number) {
      this.id = id;
      this.lat = lat;
      this.lng = lng;
  }
}
